'use client';

import Link from '@lichtblick/link';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import type { FC } from 'react';
import type { DatasourceJobLocationsType, TJobType } from '../../types/storyblok';
import styles from './job-overview.module.scss';

export interface JobProps {
  uuid: string;
  href: string;
  title: string;
  areaOfWork: TJobType['areaOfWork'];
  levelOfExperience: TJobType['levelOfExperience'];
  locations: DatasourceJobLocationsType[];
  date: string;
}

export const Job: FC<JobProps> = ({ href, title, areaOfWork, levelOfExperience, date, locations }) => (
  <Link href={href} className={styles.job}>
    <Headline size="s">{title}</Headline>
    <Text size="xs">
      {areaOfWork} | {levelOfExperience} | vom {date}
      {Boolean(locations?.length) && (
        <>
          <br />
          {locations.join(', ')}
        </>
      )}
    </Text>
  </Link>
);
